<template>
  <div class="row license-view">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-3">
          <h4 class="title">
            <span>Step 1</span>
            <small>Choose a country</small>
          </h4>
          <div class="card">
            <div class="card-header">
              <div class="form-group">
                <input type="text" placeholder="Filter countries" class="form-control" v-model="search.country">
              </div>
            </div>
            <div class="card-content table-responsive table-full-width">
              <el-table highlight-current-row :data="countries" @current-change="chooseCountry" ref="countryTable">
                <el-table-column label="Name" property="name"></el-table-column>
                <el-table-column align="right">
                  <template slot-scope="scope">
                    <span class="label label-danger" v-if="scope.row.lockedCount">
                      <i class="ti-lock"></i>
                      {{ scope.row.lockedCount }}
                    </span>
                    <span class="label label-success">{{ scope.row.siteiniCount - scope.row.lockedCount }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>


        <div class="col-md-3">
          <h4 class="title">
            <span>Step 2</span>
            <small>Choose a site.ini</small>
          </h4>
          <div class="card">
            <div class="card-header">
              <div class="form-group">
                <input type="text" placeholder="Filter site.ini" class="form-control" v-model="search.siteini">
              </div>
            </div>
            <div class="card-content table-responsive table-full-width">
              <div class="row" v-if="loader.siteini">
                <div class="col-12 text-center">
                  <img src="static/img/loader.gif">
                </div>
              </div>
              <el-table
                v-if="!loader.siteini"
                ref="siteiniTable"
                :data="siteini"
                highlight-current-row
                @current-change="chooseSiteIni"
                class="has-actions"
                style="width: 100%">
                <el-table-column width="55">
                  <template slot-scope="scope">
                    <span class="icon-success" v-if="scope.row.encrypted && !isSiteiniLocked(scope.row)">
                      <i class="ti-unlock"></i>
                    </span>
                    <span class="icon-danger" v-if="scope.row.encrypted && isSiteiniLocked(scope.row)">
                      <i class="ti-lock"></i>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  property="site"
                  label="Name">
                </el-table-column>
                <el-table-column class-name="has-actions" align="right">
                  <template slot-scope="scope">
                    <span class="label label-default" v-if="scope.row.channelUsedCount">
                      <i class="ti-na"></i>
                      {{ scope.row.channelUsedCount }}
                    </span>
                    <span class="label label-info">{{ scope.row.channelCount - scope.row.channelUsedCount }}</span>
                    <span class="siteini-row-actions" @click.stop>
                      <drop-down class="btn-group">
                        <button slot="title" class="btn btn-icon btn-simple btn-primary" data-toggle="dropdown">
                          <i class="ti-more-alt"></i>
                        </button>
                        <li><a href="#" @click.prevent="openMoveModal(scope.row)">Change site.ini country</a></li>
                        <li><a href="#" @click.prevent="openCookieModal(scope.row)">Update cookies</a></li>
                      </drop-down>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>


        <div class="col-md-3">
          <h4 class="title">
            <span>Step 3</span>
            <small>Choose channels</small>
          </h4>
          <div class="card">
            <div class="card-header">
              <div class="form-group">
                <input type="text" placeholder="Filter channels" class="form-control" v-model="search.channel">
              </div>
            </div>
            <div class="card-content table-responsive table-full-width">
              <div class="row" v-if="loader.channel">
                <div class="col-12 text-center">
                  <img src="static/img/loader.gif">
                </div>
              </div>
              <el-table
                v-if="!loader.channel"
                ref="channelTable"
                :data="channels"
                @selection-change="handleChannelSelectionChange"
                @row-click="selectChildChannel"
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  property="xmltv_id"
                  label="Name">
                </el-table-column>
                <el-table-column align="right">
                  <template slot="header" slot-scope="scope">
                    <button type="button" class="btn btn-success btn-sm btn-fill" @click="submitSelectionLicense()">
                      <span>Add selected</span>
                    </button>
                  </template>
                  <template slot-scope="scope">
                    <button type="button" class="btn btn-success btn-sm btn-fill" @click="submitChannelLicense(scope.row.id)">
                      <span>Add</span>
                    </button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>


        <div class="col-md-3">
          <h4 class="title">Selected channels</h4>
          <div class="card">
            <div class="card-header">
              <stats :licenseData="licenseData"/>
            </div>
            <div class="card-content table-responsive table-full-width selected-channels">
              <el-table
                ref="selectionTable"
                :data="assignedSiteinis"
                row-key="name"
                style="width: 100%">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <div class="btn-group channel-pill" v-for="channel in props.row.channels" :key="channel.id">
                      <button type="button" class="btn btn-fill btn-danger btn-sm" disabled="disabled">{{ channel.xmltv_id }}</button>
                      <button type="button" class="btn btn-fill btn-default btn-sm" disabled="disabled" v-if="isChannelActiveDuplicate()(channel.identifier)">D</button>
                      <button type="button" class="btn btn-fill btn-warning btn-sm" disabled="disabled" v-if="channel.ungrabbed === 1">N</button>
                      <button type="button" class="btn btn-fill btn-danger btn-sm" @click="submitChannelLicense(channel.id, null)">
                        <i class="ti-close"></i></button>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column property="name">
                  <template slot-scope="scope">
                    <span style="margin-right: 5px">{{ scope.row.name }}</span>
                    <span class="label label-default">{{ scope.row.country }}</span>
                  </template>
                </el-table-column>

                <el-table-column align="right">
                  <template slot-scope="scope">
                    <span class="label label-info">{{ scope.row.channels.length }}</span>
                    <button type="button" class="btn btn-default btn-sm btn-fill" @click="removeDuplicates(scope.row.channels)">
                      <span>RD</span>
                    </button>
                    <button type="button" class="btn btn-danger btn-sm btn-fill" @click="submitChannelLicense(scope.row.channels.map(ch => ch.id), null)">
                      <span>Remove</span>
                    </button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div>
      <b-modal ref="modal-siteini-move" hide-footer :title="'Move '+forms.moveSiteini.siteini.site+' to country'">
        <div class="container-fluid" style="padding: 12px 25px">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>Select Country</label>
                <select name="country" class="form-control" v-model="forms.moveSiteini.country">
                  <option :value="country.name" :key="country.name" v-for="country in countries">{{ country.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-fill btn-success" @click="changeSiteiniCountrySubmit">Move</button>
            </div>
          </div>
        </div>
      </b-modal>

      <b-modal ref="modal-siteini-cookie" hide-footer :title="'Set cookies for siteini '+forms.cookieSiteini.siteini.site">
        <div class="container-fluid" style="padding: 12px 25px">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>Cookies</label>
                <textarea name="cookies" cols="30" rows="10" class="form-control" v-model="forms.cookieSiteini.cookies"></textarea>
              </div>
            </div>
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-fill btn-success" @click="changeSiteiniCookiesSubmit">Update cookies</button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import Stats from "./View/Stats";
import siteini from "../../../../store/modules/siteini";

export default {
  components: {Stats},
  mounted () {
    const licenseId = this.$route.params.id;
    this.licenseFetchList();
    // this.licenseData = this.licenseById()(licenseId);
    this.siteiniFetchCountryList();
    this.channelsByLicenseId(licenseId);
    this.channelsFetchDuplicatesActive();
  },
  computed: {
    licenseData: function () {
      return this.licenseById()(this.$route.params.id)
    },
    countries: function () {
      const search = this.search.country.toLowerCase();
      let countries = this.getSiteiniCountries();
      if (countries && search !== '') {
        countries = countries.filter((country) => country.name.toLowerCase().includes(search))
      }
      return countries;
    },
    siteini: function () {
      if (this.currentRows.country) {
        const search = this.search.siteini.toLowerCase();
        const country = this.currentRows.country.name;
        let siteinis = this.getSiteiniByCountry()(country);
        if (siteinis && search !== '') {
          siteinis = siteinis.filter((siteini) => siteini.site.toLowerCase().includes(search))
        }
        return siteinis;
      }
      return [];
    },
    channels: function () {
      if (this.currentRows.siteini) {
        const search = this.search.channel.toLowerCase();
        const site = this.currentRows.siteini.site;
        let channels = this.getChannelsBySiteini()(site);
        if (channels && search !== '') {
          channels = channels.filter((country) => country.xmltv_id.toLowerCase().includes(search))
        }
        return channels;
      }
      return [];
    },
    assignedSiteinis: function () {
      let siteinis = {}, result = [];
      const assignedChannels = this.getChannelsByLicense()(this.$route.params.id);
      console.log('assignedChannels', assignedChannels);
      assignedChannels.forEach(channel => {
        // if (!siteinis.includes(channel.siteini.site)) {
        if (!siteinis[channel.siteini.site]) {
          siteinis[channel.siteini.site] = channel.siteini;
        }
      });

      const siteiniSites = Object.keys(siteinis);
      siteiniSites.forEach(site => result.push({
        name: site,
        country: siteinis[site].country,
        channels: assignedChannels.filter(channel => channel.siteini.site === site)
      }))
      console.log('siteinis', siteinis)
      return result;
    },
  },
  data: function () {
    return {
      search: {
        country: '',
        siteini: '',
        channel: ''
      },
      currentRows: {
        country: {},
        siteini: {}
      },
      selectedChannels: [],
      forms: {
        moveSiteini: {
          country: "",
          siteini: {}
        },
        cookieSiteini: {
          cookies: "",
          siteini: {}
        }
      },
      loader: {
        siteini: false,
        channel: false
      },
      selection: {
        lastItem: false
      }
    }
  },
  methods: {
    ...mapActions([
      'setErrorMessages',
      'setInfoMessages',
      'licenseFetchList',
      'siteiniFetchCountryList',
      'siteiniFetchList',
      'channelsBySiteini',
      'channelsByLicenseId',
      'channelsFetchDuplicatesActive',
      'assignLicenseToChannels',
      'siteiniOperationMove',
      'siteiniOperationCookie',
    ]),
    ...mapGetters([
      'licenseById',
      'getSiteiniCountries',
      'getSiteiniByCountry',
      'getChannelsByLicense',
      'getChannelsBySiteini',
      'isChannelActiveDuplicate'
    ]),
    submitChannelLicense: function (channelIds, licenseId = false) {
      licenseId = (licenseId === false) ? this.licenseData.id : licenseId;
      channelIds = (!Array.isArray(channelIds)) ? [channelIds] : channelIds;

      if (licenseId !== null) {
        // if (this.licenseData.allowedChannels < this.licenseData.usedChannels + channelIds.length) {
        //   this.setErrorMessages([{message: 'Adding selected channels would surpass license channel limit.'}]);
        //   return false;
        // }
        //
        // if (this.licenseData.allowedSiteinis < this.licenseData.usedSiteinis + 1) {
        //   this.setErrorMessages([{message: 'Adding selected channels would surpass license site.ini limit.'}]);
        //   return false;
        // }
      }
      this.assignLicenseToChannels({licenseId: licenseId, channels: channelIds});
      this.channelsFetchDuplicatesActive();
      this.licenseFetchList();
    },
    submitSelectionLicense: function () {
      const channelIds = this.selectedChannels.map(el => el['id']);
      this.submitChannelLicense(channelIds);
    },
    chooseCountry: async function (row) {
      this.currentRows.country = row
      if (row) {
        this.loader.siteini = true;
        this.$refs.channelTable.setCurrentRow(null)
        this.$refs.siteiniTable.setCurrentRow(null)
        await this.siteiniFetchList(row.name)
        this.loader.siteini = false;
      }
    },
    chooseSiteIni: async function (row) {
      if (row && row.encrypted && this.isSiteiniLocked(row)) {
        this.$refs.siteiniTable.setCurrentRow(null);
        this.setInfoMessages('This site.ini is encrypted and no decrypt key was provided')
        return;
      }

      this.currentRows.siteini = row;
      if (row) {
        this.loader.channel = true;
        this.setInfoMessages([]);
        this.$refs.channelTable.setCurrentRow(null);
        await this.channelsBySiteini(row.site);
        this.loader.channel = false;
      }
    },
    handleChannelSelectionChange (values) {
      this.selectedChannels = values;
    },
    isSiteiniLocked (site) {
      if (site && site.decrypt_key && site.decrypt_key.status) {
        return [1, 4].includes(site.decrypt_key.status);
      }
      return true;
    },
    openMoveModal: function (row) {
      if (row && row.country) {
        this.forms.moveSiteini.siteini = row;
        this.forms.moveSiteini.country = row.country;
        this.$refs['modal-siteini-move'].show();
      }
    },
    openCookieModal: function (row) {
      console.log('row', row)
      if (row) {
        this.forms.cookieSiteini.siteini = row;
        this.forms.cookieSiteini.cookies = row.cookies;
        this.$refs['modal-siteini-cookie'].show();
      }
    },
    changeSiteiniCountrySubmit () {
      const id = this.forms.moveSiteini.siteini.id;
      const country = this.forms.moveSiteini.country;
      if (id && country) {
        this.siteiniOperationMove({subject: id, country: country})
        this.$refs['modal-siteini-move'].hide();
      }
    },
    changeSiteiniCookiesSubmit () {
      const id = this.forms.cookieSiteini.siteini.id;
      const cookies = this.forms.cookieSiteini.cookies;
      if (id && cookies) {
        this.siteiniOperationCookie({subject: id, cookies: cookies})
        this.$refs['modal-siteini-cookie'].hide();
      }
    },
    selectChildChannel (row, column, event) {
      if (event.shiftKey && this.selection.lastItem) {
        let start = false;
        const markers = [this.selection.lastItem.id, row.id];
        this.channels.forEach((channel) => {
          if (!start && markers.includes(channel.id)) {
            start = true;
            return;
          }
          if (start) this.$refs.channelTable.toggleRowSelection(channel)
          if (start && markers.includes(channel.id)) start = false;
        });
        this.selection.lastItem = row;
      } else {
        this.$refs.channelTable.toggleRowSelection(row);
        this.selection.lastItem = row;
      }
    },
    removeDuplicates (channels) {
      if (channels.length) {
        var duplicates = channels.filter(channel => this.isChannelActiveDuplicate()(channel.identifier))
        var duplicateIds = duplicates.map(channel => channel.id)
        if (duplicateIds.length) {
          this.submitChannelLicense(duplicateIds, null)
        }
      }
    }
  }

}
</script>
<style>
.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.selected-channels .el-table__header-wrapper {
  display: none;
}

.selected-channels .el-table__body-wrapper {
  border-top: 1px solid #ebeef5;
}

.channel-pill {
  margin: 0 7px 7px 0;
}

.license-view .el-table__body tr.el-table__row.selected-row > td {
  background: #7AC29A;
  color: #fff;
  font-weight: bold;
}

.license-view .el-table__body tr.el-table__row.current-row > td {
  font-weight: bold;
  color: #fff;
  background: #66615B;
}

.license-view .siteini-row-actions {
  position: relative;
}

.license-view .siteini-row-actions .action-list {
  position: absolute;
}

.license-view .el-table.has-actions {
  overflow: visible;
}

.license-view .el-table.has-actions .el-table__body-wrapper {
  overflow: visible;
}

.license-view .el-table__row .el-table__cell.has-actions .cell {
  overflow: visible;
}

.license-view .el-table__row .el-table__cell.has-actions .dropdown-menu {
  left: auto;
  right: 0;
}

.modal.fade.show {
  opacity: 1 !important;
}

.modal-dialog {
  margin: 120px auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Licenses/View.vue